var _mask, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandingPageShowIcon = function SvgLandingPageShowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 34,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "LandingPageShowIcon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M29 15.502c0 6.904-5.597 12.5-12.5 12.5-6.904 0-12.5-5.596-12.5-12.5 0-6.903 5.596-12.5 12.5-12.5 6.903 0 12.5 5.597 12.5 12.5m3 0c0 8.56-6.94 15.5-15.5 15.5A15.43 15.43 0 0 1 7.328 28l-3.706 4.608a1.5 1.5 0 0 1-2.338-1.88l3.806-4.733A15.44 15.44 0 0 1 1 15.502C1 6.942 7.94.002 16.5.002S32 6.942 32 15.502",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LandingPageShowIcon_svg__a)",
    d: "m7.328 27.999 1.777-2.418L6.79 23.88l-1.8 2.238zm-3.706 4.608 2.338 1.88zm-2.109.229 1.88-2.338zm-.229-2.11 2.338 1.88zm3.806-4.732 2.338 1.88 1.618-2.012-1.748-1.9zm11.41 5.008c8.56 0 15.5-6.94 15.5-15.5h-6a9.5 9.5 0 0 1-9.5 9.5zM1 15.502c0 8.56 6.94 15.5 15.5 15.5v-6a9.5 9.5 0 0 1-9.5-9.5zM16.5.002C7.94.002 1 6.942 1 15.502h6a9.5 9.5 0 0 1 9.5-9.5zm15.5 15.5c0-8.56-6.94-15.5-15.5-15.5v6a9.5 9.5 0 0 1 9.5 9.5zm-15.5 18.5c10.217 0 18.5-8.283 18.5-18.5h-6c0 6.904-5.597 12.5-12.5 12.5zM5.55 30.415a18.43 18.43 0 0 0 10.95 3.587v-6a12.43 12.43 0 0 1-7.395-2.42zm-.56-4.297-3.706 4.609 4.676 3.76 3.706-4.609zm-3.706 4.609a1.5 1.5 0 0 1 2.11-.23l-3.761 4.676a4.5 4.5 0 0 0 6.327-.686zm2.11-.23a1.5 1.5 0 0 1 .228 2.11l-4.676-3.76a4.5 4.5 0 0 0 .687 6.326zm.228 2.11 3.806-4.733-4.675-3.76-3.807 4.732zM-2 15.502c0 4.828 1.853 9.23 4.883 12.523l4.415-4.062A12.45 12.45 0 0 1 4 15.503zm18.5-18.5C6.282-2.998-2 5.285-2 15.502h6c0-6.903 5.596-12.5 12.5-12.5zm18.5 18.5c0-10.217-8.283-18.5-18.5-18.5v6c6.903 0 12.5 5.597 12.5 12.5z",
    mask: "url(#LandingPageShowIcon_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "LandingPageShowIcon_svg__a",
    x1: 0.953,
    x2: 32.333,
    y1: 0.002,
    y2: 35.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#fff",
    stopOpacity: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgLandingPageShowIcon;